(function(){
  function goHomeIfOldRoute(){
    var path=window.location.pathname;
    if(path==='/'||path==='') return;
    var hash=window.location.hash || '';
    var target='/'+hash;
    window.location.replace(target);
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',goHomeIfOldRoute);
  } else { goHomeIfOldRoute(); }
})();
